module.exports = __webpack_public_path__ + "img/kgn_color.dc5c83d9.png";